import { Paper, SwipeableDrawer, SwipeableDrawerProps, styled } from "@mui/material";
import { grey } from "@mui/material/colors";
import { getTheme } from "../theme";

const Puller = styled('div')(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: grey[300],
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
    ...theme.applyStyles('dark', {
        backgroundColor: grey[900],
    }),
}));

export default function MobileSwipeableDrawer({ PaperProps, children, ...props }: SwipeableDrawerProps) {
    return <SwipeableDrawer keepMounted anchor="bottom"
        PaperProps={{
            sx: {
                backgroundColor: 'transparent',
                p: 0,
                m: 0,
                border: 'none',
                maxHeight: 'calc(100vh - 50px - env(safe-area-inset-top))'
            }
        }}
        {...props}    >
        <Puller />
        <Paper component="form"
            {...PaperProps}
            sx={{
                display: "flex",
                flexDirection: "column",
                p: 2,
                pb: 'calc(env(safe-area-inset-bottom) + ' + getTheme().spacing(1) + ')',
                gap: 1, m: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                overflow: 'hidden',
                ...PaperProps?.sx
            }}>
            {children}
        </Paper>
    </SwipeableDrawer>
}